export default {
	search(params, cb, ecb) {
		this.http
			.get('/price', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/price', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb) {
		this.http.get('/price/' + id, {}).then((r) => cb && cb(r))
	},

	searchLevel(params, cb, ecb) {
		this.http
			.get('/price/level', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateLevel(form, cb, ecb) {
		this.http
			.post('/price/level', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getLevelById(id, cb) {
		this.http.get('/price/level/' + id, {}).then((r) => cb && cb(r))
	}
}
